import ForgotPassword from "../../container/auth/forgot";

export default ForgotPassword;
